import { render, staticRenderFns } from "./uploadslide.vue?vue&type=template&id=5e2676a8&scoped=true"
import script from "./uploadslide.vue?vue&type=script&lang=js"
export * from "./uploadslide.vue?vue&type=script&lang=js"
import style0 from "./uploadslide.vue?vue&type=style&index=0&id=5e2676a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2676a8",
  null
  
)

export default component.exports